export const inPageTabsLoad = () => {
	const tabContainer = document.querySelector(".in-page-tabs-container");
	const tabContentEls = tabContainer?.querySelectorAll(".tabs-content > div");

	function tabHandler(e) {
		e.preventDefault();
		const tabLabels = tabContainer.querySelectorAll(".tab-item a");
		tabLabels.forEach((label) => {
			label.classList.remove("active");
		});
		[].forEach.call(tabContentEls, (pane) => {
			pane.classList.remove("active");
		});
		e.target.classList.add("active");
		const clickedTab = e.target.getAttribute("href");
		document.querySelector(clickedTab).classList.add("active");
		window.history.pushState({}, "", `${window.location.pathname}${clickedTab}`);
	}

	if (tabContentEls?.length > 1) {
		const tabList = document.createElement("ul");
		tabList.setAttribute("class", "in-page-tabs-list");
		[...tabContentEls].forEach((c, i) => {
			let activeTab = "";
			if (window.location.hash) {
				activeTab = window.location.hash.substring(1);
				if (c.id === activeTab) {
					c.classList.add("active");
				}
			}
			if (!activeTab) {
				if (i === 0) c.classList.add("active");
			}

			const tabItem = document.createElement("li");
			tabItem.setAttribute("class", "tab-item");
			const tabAnchor = document.createElement("a");
			tabAnchor.setAttribute(
				"class",
				`tab-title t-body-md-heavy ${
					!activeTab && i === 0 ? "active" : c.id === activeTab ? "active" : ""
				}`
			);
			tabAnchor.setAttribute("href", "#" + c.id);
			tabAnchor.setAttribute("data-a-evt", "Subcontent View");
			tabAnchor.setAttribute("data-a-comp", "Nav Tab");
			tabAnchor.setAttribute("data-a-text", c.dataset.title);
			tabAnchor.innerHTML = c.dataset.title;
			tabAnchor.addEventListener("click", tabHandler);

			tabItem.appendChild(tabAnchor);
			tabList.appendChild(tabItem);
		});
		tabContainer.prepend(tabList);
	}
};
